module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "project-title"
  }, [_vm._v("VINTAGE TEAPOT QUILT")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("This is the perfect quilt to have on display when friends drop by for a cup of tea. Three different teapot blocks in pretty prints sit on bunting-edged shelves. A fresh solid fabric is used for the background and this sky teal colour contrasts beautifully with the pictorial blocks. There’s also a pretty fern green version of this quilt, which you can find at "), _c('a', {
    attrs: {
      "href": "http://www.tildasworld.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tildasworld.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F1.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("MATERIALS")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Fabric 1: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("yd (50cm) – Bonnie red")]), _vm._v(" "), _c('li', [_vm._v("Fabric 2: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("yd (50cm) – Nancy red")]), _vm._v(" "), _c('li', [_vm._v("Fabric 3: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("yd (50cm) – Billy Jo red")]), _vm._v(" "), _c('li', [_vm._v("Fabric 4: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v("yd (40cm) – Shirley teal")]), _vm._v(" "), _c('li', [_vm._v("Fabric 5: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v("yd (40cm) – Shirly dove white")]), _vm._v(" "), _c('li', [_vm._v("Fabric 6: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v("yd (40cm) – Medium Dots red")]), _vm._v(" "), _c('li', [_vm._v("Fabric 7: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v("yd (40cm) – Shirly red")]), _vm._v(" "), _c('li', [_vm._v("Fabric 8: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v("yd (40cm) – Nancy teal")]), _vm._v(" "), _c('li', [_vm._v("Fabric 9: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v("yd (15cm) – Pen Stripe light blue")]), _vm._v(" "), _c('li', [_vm._v("Fabric 10: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("yd (25cm) – Tiny Star light blue")]), _vm._v(" "), _c('li', [_vm._v("Fabric 11: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v("yd (40cm) – Crisscross light blue")]), _vm._v(" "), _c('li', [_vm._v("Fabric 12: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("yd (25cm) – Paint Dots light blue")]), _vm._v(" "), _c('li', [_vm._v("Fabric 13: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("yd (25cm) – Tiny Dots light blue")]), _vm._v(" "), _c('li', [_vm._v("Fabric 14: "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v("yd (15cm) – Dottie Dots light blue")]), _vm._v(" "), _c('li', [_vm._v("Fabric 15: 3"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v("yd (3m) – Solid sky teal")]), _vm._v(" "), _c('li', [_vm._v("Backing fabric 3"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("yd (3.2m)")]), _vm._v(" "), _c('li', [_vm._v("Wadding (batting) 60in x 82in (152.4cm x 208.3cm)")]), _vm._v(" "), _c('li', [_vm._v("Binding fabric "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("yd (50cm) – Pearls yellow")]), _vm._v(" "), _c('li', [_vm._v("Removable fabric marker")])]), _vm._v(" "), _c('p', {
    staticClass: "finish-head"
  }, [_c('b', [_vm._v("Finished Size")]), _vm._v(" 52in x 74in (132cm x 188cm)")]), _vm._v(" "), _c('p', {
    staticClass: "finish-head"
  }, [_c('b', [_vm._v("Fabric Note")]), _vm._v(" Where a long eighth or long quarter of a yard is given in the Materials list you could use fat eighths and fat quarters instead. A fat eighth is assumed to be approx. 10"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in x 18in (26.7cm x 45.7cm) and a fat quarter approx. 21in x 18in (53.3cm x 45.7cm).")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("PREPARATION AND CUTTING OUT")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("1")]), _vm._v(" Before you start, refer to "), _c('span', {
    attrs: {
      "href": "#/Techniques#CT-F1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Techniques: Making Quilts and Pillows")]), _vm._v(". This quilt is made up of three different teapot blocks – Block 1 (in two different colourways), Block 2 (in four different colourways) and Block 3 (in two different colourways). The teapots are arranged in rows, separated by narrow sashing strips. Narrow rows of flying geese blocks are used like bunting between the teapot rows. The fabrics used are shown in "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figA"
    }
  }, [_c('b', [_vm._v("Fig A")])]), _vm._v(" and the quilt layout in "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figB"
    }
  }, [_c('b', [_vm._v("Fig B")])]), _vm._v(". The different colourways for the teapot blocks are shown in "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figC"
    }
  }, [_c('b', [_vm._v("Fig C")])]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig A")]), _vm._v(" Fabric swatches – if you can’t source a fabric, replace with one in a similar colour")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figA"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig B")]), _vm._v(" Quilt layout")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figB"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig C")]), _vm._v(" Block colourways"), _c('br'), _vm._v("Numbers indicate fabrics (see "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figA"
    }
  }, [_vm._v("Fig A")]), _vm._v(")"), _c('br'), _vm._v("Make 3 of each block")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figC"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F4.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("2")]), _vm._v(" For the print fabrics for the teapot blocks, follow the exact measurements for cutting out the pieces for each block in "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figD"
    }
  }, [_c('b', [_vm._v("Fig D")])]), _vm._v(", "), _c('b', [_c('a', {
    attrs: {
      "href": "#/Chapter3#figE"
    }
  }, [_vm._v("Fig E")])]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figF"
    }
  }, [_c('b', [_vm._v("Fig F")])]), _vm._v(". Seam allowances are included in these measurements.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig D")]), _vm._v(" Layout and cutting for Block 1")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figD"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F5.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig E")]), _vm._v(" Layout and cutting for Block 2")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figE"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F6.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig F")]), _vm._v(" Layout and cutting for Block 3")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figF"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F7.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("3")]), _vm._v(" All of the teapot blocks use the solid sky teal Fabric 15 as a background, so there are many pieces to cut. You could cut these now if desired, putting them in labelled piles (or cut the pieces as you make each block). Use the cut sizes given in "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figD"
    }
  }, [_c('b', [_vm._v("Fig D")])]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figE"
    }
  }, [_c('b', [_vm._v("Fig E")])]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figF"
    }
  }, [_c('b', [_vm._v("Fig F")])]), _vm._v(". The shapes are squares and rectangles, so cut the fabric in strips across the width and then sub-cut into the sizes needed.")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("4")]), _vm._v(" For the Fabric 15 vertical sashing strips cut thirty 1"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("in x 10"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (3.2cm x 26.7cm).")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("5")]), _vm._v(" For the flying geese blocks cut 182 squares 2"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (6.4cm) from Fabric 15.")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("6")]), _vm._v(" For the flying geese blocks cut 4"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in x 2"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (11.4cm x 6.4cm) rectangles (ninety-one in total) from the following print fabrics.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Fabric 1 – sixteen rectangles.")]), _vm._v(" "), _c('li', [_vm._v("Fabric 2 – twelve rectangles.")]), _vm._v(" "), _c('li', [_vm._v("Fabric 3 – twelve rectangles.")]), _vm._v(" "), _c('li', [_vm._v("Fabric 4 – twelve rectangles.")]), _vm._v(" "), _c('li', [_vm._v("Fabric 5 – twelve rectangles.")]), _vm._v(" "), _c('li', [_vm._v("Fabric 6 – nine rectangles.")]), _vm._v(" "), _c('li', [_vm._v("Fabric 7 – nine rectangles.")]), _vm._v(" "), _c('li', [_vm._v("Fabric 8 – nine rectangles.")])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("7")]), _vm._v(" Cut the backing fabric in half across the width. Sew together along the long side. Press the seam open and trim to a piece about 60in x 82in (152.4cm x 208.3cm).")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("8")]), _vm._v(" From the binding fabric cut seven strips 2"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (6.4cm) x width of fabric. Sew together end to end and press seams open. Press in half along the length, wrong sides together.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("MAKING A BLOCK 1 TEAPOT")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("9")]), _vm._v(" Each Block 1 is made the same way, but in two different colourways (see "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figC"
    }
  }, [_c('b', [_vm._v("Fig C")])]), _vm._v("). Block 1A is described in detail here. "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figD"
    }
  }, [_c('b', [_vm._v("Fig D")])]), _vm._v(" shows the layout of the block, with the letters indicating the cut sizes of the fabric pieces. When you have cut all the pieces for one block, lay them out in the different sections of the block as best you can.")]), _vm._v(" "), _c('p', {
    staticClass: "step",
    attrs: {
      "id": "C3-1"
    }
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("10")]), _vm._v(" Follow "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figG"
    }
  }, [_c('b', [_vm._v("Fig G")])]), _vm._v(" for sewing the spout. Create a triangle on a corner as follows. On the wrong side of a "), _c('b', [_vm._v("c")]), _vm._v(" square mark a diagonal line. Place the square right sides together with piece "), _c('b', [_vm._v("b")]), _vm._v(", matching the top edges. Sew along the marked diagonal. Trim excess fabric "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("in (6mm) away from the sewn line and press the corner outwards. Repeat this process with piece "), _c('b', [_vm._v("d")]), _vm._v(" and two "), _c('b', [_vm._v("e")]), _vm._v(" squares.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig G")]), _vm._v(" Sewing the Block 1 spout")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figG"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F8.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("11")]), _vm._v(" Now sew units "), _c('b', [_vm._v("b/c")]), _vm._v(" together with unit "), _c('b', [_vm._v("d/e/e")]), _vm._v(". Take this pieced unit and add the two rectangle pieces "), _c('b', [_vm._v("a")]), _vm._v(" to the top and bottom, and press. Set aside for the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "step",
    attrs: {
      "id": "C3-2"
    }
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("12")]), _vm._v(" Follow "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figH"
    }
  }, [_c('b', [_vm._v("Fig H")])]), _vm._v(" for sewing the lid. Sew pieces "), _c('b', [_vm._v("g, h")]), _vm._v(" and "), _c('b', [_vm._v("g")]), _vm._v(" together in a row and press. Add piece "), _c('b', [_vm._v("i")]), _vm._v(" to the bottom of the unit. Now sew piece "), _c('b', [_vm._v("f")]), _vm._v(" to the left-hand side of the unit and piece "), _c('b', [_vm._v("j")]), _vm._v(" to the right-hand side, and press. Set the unit aside for the moment.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig H")]), _vm._v(" Sewing the Block 1 lid")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figH"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F9.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("13")]), _vm._v(" Follow "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figI"
    }
  }, [_c('b', [_vm._v("Fig I")])]), _vm._v(" for sewing the teapot body and handle. Sew pieces "), _c('b', [_vm._v("k")]), _vm._v(" and "), _c('b', [_vm._v("l")]), _vm._v(" together and press ("), _c('a', {
    attrs: {
      "href": "#/Chapter3#figI"
    }
  }, [_c('b', [_vm._v("Fig I 1")])]), _vm._v("). Sew pieces "), _c('b', [_vm._v("n")]), _vm._v(" and "), _c('b', [_vm._v("o")]), _vm._v(" together and press ("), _c('a', {
    attrs: {
      "href": "#/Chapter3#figI"
    }
  }, [_c('b', [_vm._v("Fig I 2")])]), _vm._v("). Take unit "), _c('b', [_vm._v("k/l")]), _vm._v(" and on the wrong side use an erasable marker to mark the "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("in (6mm) seam allowance all round. On this unit, also mark a diagonal line from corner to corner of the seam allowance (not the outer corners of the shape). On the right side of piece "), _c('b', [_vm._v("m")]), _vm._v(" mark the "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("in (6mm) seam allowance. On piece "), _c('b', [_vm._v("m")]), _vm._v(", mark a dot 2"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("in (5.7cm) away from the top right-hand edge of the fabric, as shown on "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figI"
    }
  }, [_c('b', [_vm._v("Fig I 3")])]), _vm._v(". Mark another dot at the bottom right-hand side, on the "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("in (6mm) seam allowance corner.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig I")]), _vm._v(" Sewing the Block 1 body and handle")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figI"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F10.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("14")]), _vm._v(" Place unit "), _c('b', [_vm._v("k/l")]), _vm._v(" right sides together with piece "), _c('b', [_vm._v("m")]), _vm._v(", angling the narrow unit as shown in the diagram, so the dots match up at the top and bottom. Pin in place and then sew along the marked diagonal line (you can sew to the edges of the fabric). Trim excess fabric "), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("in (6mm) away from the sewn line and press the triangle outwards. To complete the body and handle, sew unit "), _c('b', [_vm._v("n/o")]), _vm._v(" to the right-hand side.")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("15")]), _vm._v(" To assemble the block follow "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figJ"
    }
  }, [_c('b', [_vm._v("Fig J")])]), _vm._v(". Sew the lid section to the body section and press. Now add the spout section and press. The block should be 10in x 10"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (25.4cm x 26.7cm) at this stage.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig J")]), _vm._v(" Assembling Block 1")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figJ"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F11.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("16")]), _vm._v(" Make three of Block 1A like this in total. Repeat the process and change fabrics to sew three of Block 1B – see "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figC"
    }
  }, [_c('b', [_vm._v("Fig C")])]), _vm._v(" for fabrics used.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("MAKING A BLOCK 2 TEAPOT")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("17")]), _vm._v(" Each Block 2 is made the same way, but in four different colourways (see "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figC"
    }
  }, [_c('b', [_vm._v("Fig C")])]), _vm._v("). Block 2A is described in detail here. "), _c('b', [_c('a', {
    attrs: {
      "href": "#/Chapter3#figE"
    }
  }, [_vm._v("Fig E")])]), _vm._v(" shows the layout of the block, with the letters indicating the cut sizes of the fabric pieces. When you have cut all the pieces for one block, lay them out in the different sections of the block as best you can.")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("18")]), _vm._v(" For the spout, use pieces "), _c('b', [_vm._v("b, c, d, e")]), _vm._v(" and "), _c('b', [_vm._v("f")]), _vm._v(", and follow the same basic process as described in the "), _c('a', {
    attrs: {
      "href": "#/Chapter3#C3-1"
    }
  }, [_vm._v("Block 1 teapot (Steps 10–11)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("19")]), _vm._v(" For the lid, use pieces "), _c('b', [_vm._v("g, h, i")]), _vm._v(" and "), _c('b', [_vm._v("j")]), _vm._v(", and follow the same basic process as described in the "), _c('a', {
    attrs: {
      "href": "#/Chapter3#C3-2"
    }
  }, [_vm._v("Block 1 teapot (Step 12)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "step",
    attrs: {
      "id": "C3-3"
    }
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("20")]), _vm._v(" For the teapot body following "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figK"
    }
  }, [_c('b', [_vm._v("Fig K")])]), _vm._v(". Take piece "), _c('b', [_vm._v("k")]), _vm._v(" and four "), _c('b', [_vm._v("l")]), _vm._v(" squares and create triangle corners on the larger piece, using the same technique described for "), _c('a', {
    attrs: {
      "href": "#/Chapter3#C3-1"
    }
  }, [_vm._v("Block 1 (Step 10)")]), _vm._v(". For the base of the body, sew two "), _c('b', [_vm._v("m")]), _vm._v(" pieces to the sides of an "), _c('b', [_vm._v("n")]), _vm._v(" piece. Press and then sew this to the bottom of the body.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig K")]), _vm._v(" Sewing a Block 2 body")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figK"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F12.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step",
    attrs: {
      "id": "C3-4"
    }
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("21")]), _vm._v(" To make the handle follow the sequence in "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figL"
    }
  }, [_c('b', [_vm._v("Fig L")])]), _vm._v(". Start by sewing the two "), _c('b', [_vm._v("q")]), _vm._v(" pieces to the top and bottom of the "), _c('b', [_vm._v("p")]), _vm._v(" piece. Press and then add piece "), _c('b', [_vm._v("r")]), _vm._v(" to the right-hand side of the unit ("), _c('a', {
    attrs: {
      "href": "#/Chapter3#figL"
    }
  }, [_c('b', [_vm._v("Fig L 1")])]), _vm._v("). The corners "), _c('b', [_vm._v("s")]), _vm._v(" and then "), _c('b', [_vm._v("t")]), _vm._v(" are created using the same technique described for "), _c('a', {
    attrs: {
      "href": "#/Chapter3#C3-1"
    }
  }, [_vm._v("Block 1 (Step 10)")]), _vm._v(" – follow "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figL"
    }
  }, [_c('b', [_vm._v("Fig L 2")])]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figL"
    }
  }, [_c('b', [_vm._v("Fig L 3")])]), _vm._v(". Finally, add piece "), _c('b', [_vm._v("o")]), _vm._v(" to the top of the handle and piece "), _c('b', [_vm._v("u")]), _vm._v(" to the bottom and press ("), _c('a', {
    attrs: {
      "href": "#/Chapter3#figL"
    }
  }, [_c('b', [_vm._v("Fig L 4")])]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig L")]), _vm._v(" Sewing a Block 2 body")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figL"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F13.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("22")]), _vm._v(" To assemble the block follow "), _c('b', [_c('a', {
    attrs: {
      "href": "#/Chapter3#figM"
    }
  }, [_vm._v("Fig M")])]), _vm._v(". Sew the spout section and the handle section to the body section and press. Add the long strip of piece "), _c('b', [_vm._v("a")]), _vm._v(" to the top of the block. The block should be 14in x 10"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (35.5cm x 26.7cm) at this stage.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig M")]), _vm._v(" Assembling Block 2")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figM"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F14.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("23")]), _vm._v(" Make three of Block 2A like this in total. Repeat the process and change fabrics to sew three of Block 2B, 2C and 2D – see "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figC"
    }
  }, [_c('b', [_vm._v("Fig C")])]), _vm._v(" for the fabrics used.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("MAKING A BLOCK 3 TEAPOT")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("24")]), _vm._v(" Each Block 3 is made the same way, but in two different colourways (see "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figC"
    }
  }, [_c('b', [_vm._v("Fig C")])]), _vm._v("). Block 3A is described in detail here. "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figF"
    }
  }, [_c('b', [_vm._v("Fig F")])]), _vm._v(" shows the layout of the block, with the letters indicating the cut sizes of the fabric pieces. When you have cut all the pieces for one block, lay them out in the different sections of the block as best you can.")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("25")]), _vm._v(" For the spout, use pieces "), _c('b', [_vm._v("a, b, c, d, e")]), _vm._v(" and "), _c('b', [_vm._v("f")]), _vm._v(", and follow the same basic process as described in the "), _c('a', {
    attrs: {
      "href": "#/Chapter3#C3-1"
    }
  }, [_vm._v("Block 1 teapot (Steps 10–11)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("26")]), _vm._v(" For the lid, use pieces "), _c('b', [_vm._v("g, h, i")]), _vm._v(" and "), _c('b', [_vm._v("j")]), _vm._v(", and follow the same basic process as described in the "), _c('a', {
    attrs: {
      "href": "#/Chapter3#C3-2"
    }
  }, [_vm._v("Block 1 teapot (Step 12)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("27")]), _vm._v(" For the teapot body and base use pieces "), _c('b', [_vm._v("k, l, m")]), _vm._v(" and "), _c('b', [_vm._v("n")]), _vm._v(", and follow the same basic process as described in the "), _c('a', {
    attrs: {
      "href": "#/Chapter3#C3-3"
    }
  }, [_vm._v("Block 2 teapot (Step 20)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("28")]), _vm._v(" For the handle, use pieces "), _c('b', [_vm._v("o, p, q, r, s, t")]), _vm._v(" and "), _c('b', [_vm._v("u")]), _vm._v(", and follow the same basic process as described in the "), _c('a', {
    attrs: {
      "href": "#/Chapter3#C3-4"
    }
  }, [_vm._v("Block 2 teapot (Step 21)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("29")]), _vm._v(" To assemble the block follow "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figN"
    }
  }, [_c('b', [_vm._v("Fig N")])]), _vm._v(". Sew the lid section to the body section and press. Now add the spout section and the handle section and press. The block should be 12in x 10"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (30.5cm x 26.7cm) at this stage.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig N")]), _vm._v(" Assembling Block 3")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figN"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F15.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("30")]), _vm._v(" Make three of Block 3A like this in total. Repeat the process and change fabrics to sew three of Block 3B – see "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figC"
    }
  }, [_c('b', [_vm._v("Fig C")])]), _vm._v(" for fabrics used.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("MAKING THE FLYING GEESE ROWS")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("31")]), _vm._v(" There are seven rows of flying geese units in the quilt – Row 1 is repeated four times and Row 2 repeated three times. Use print fabrics 1, 2, 3, 4, 5, 6, 7 and 8. Each of the flying geese units is made the same way, using the same technique that you used in Block 1 to create the corner triangles. For each unit, use one 4"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in x 2"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (11.4cm x 6.4cm) rectangle of print fabric and two 2"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (6.4cm) squares of solid Fabric 15. Follow "), _c('b', [_c('a', {
    attrs: {
      "href": "#/Chapter3#figO"
    }
  }, [_vm._v("Fig O")])]), _vm._v(" for the stages of sewing. Each unit needs to be 4"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in x 2"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (11.4cm x 6.4cm) unfinished. Make a total of ninety-one units, in the following fabric combinations.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Fabrics 1 and 15 – make sixteen units.")]), _vm._v(" "), _c('li', [_vm._v("Fabrics 2 and 15 – make twelve units.")]), _vm._v(" "), _c('li', [_vm._v("Fabrics 3 and 15 – make twelve units.")]), _vm._v(" "), _c('li', [_vm._v("Fabrics 4 and 15 – make twelve units.")]), _vm._v(" "), _c('li', [_vm._v("Fabrics 5 and 15 – make twelve units.")]), _vm._v(" "), _c('li', [_vm._v("Fabrics 6 and 15 – make nine units.")]), _vm._v(" "), _c('li', [_vm._v("Fabrics 7 and 15 – make nine units.")]), _vm._v(" "), _c('li', [_vm._v("Fabrics 8 and 15 – make nine units.")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig O")]), _vm._v(" Making a flying geese unit")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figO"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F16.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("32")]), _vm._v(" Lay out the flying geese in the order shown in "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figP"
    }
  }, [_c('b', [_vm._v("Fig P")])]), _vm._v(". Note that there are four different units – Unit 1A and 1B, and Unit 2A and 2B. Sew the units together as in the diagram. Repeat the process to make the number of units stated.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig P")]), _vm._v(" Sewing the bunting units Numbers indicate fabrics used")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figP"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F17.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("33")]), _vm._v(" Now sew the units together into Row 1 and Row 2, as shown in "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figQ"
    }
  }, [_c('b', [_vm._v("Fig Q")])]), _vm._v(". Repeat, so you have four of Row 1 and three of Row 2.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig Q")]), _vm._v(" Sewing the bunting rows together")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figQ"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F18.jpg"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("ASSEMBLING THE QUILT")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("34")]), _vm._v(" Lay out the first row of teapot blocks as in "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figR"
    }
  }, [_c('b', [_vm._v("Fig R")])]), _vm._v(". Arrange the 1"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("in x 10"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in (3.2cm x 26.7cm) vertical sashing pieces in between the blocks and at the ends of the row. Sew the row together. Now follow "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figB"
    }
  }, [_c('b', [_vm._v("Fig B")])]), _vm._v(" carefully to sew the rest of the rows, changing the positions of the teapot blocks as shown.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Fig R")]), _vm._v(" Sewing a teapot row together")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "figR"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F19.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("35")]), _vm._v(" When all of the teapot rows are sewn, sew the flying geese rows between each teapot row, and at the top and bottom of the quilt. Ease the rows to fit together neatly, pinning well. Start with flying geese Row 1 at the top, then Row 2 and alternate as in "), _c('a', {
    attrs: {
      "href": "#/Chapter3#figB"
    }
  }, [_c('b', [_vm._v("Fig B")])]), _vm._v(". Press to finish.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("QUILTING AND FINISHING")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("36")]), _vm._v(" Make a quilt sandwich of the backing fabric, wadding (batting) and quilt. Quilt as desired. Square up the quilt, trimming excess wadding and backing.")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('span', {
    staticClass: "step-number"
  }, [_vm._v("37")]), _vm._v(" Use the prepared double-fold binding strip to bind your quilt (see "), _c('span', {
    attrs: {
      "href": "#/Techniques#B",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Techniques: Binding")]), _vm._v("). Add a label and your quilt is finished.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C3-F21.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b84c78d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter3.vue
// module id = 75
// module chunks = 0